export const ControllerTimeOut = () => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), 240000);

  return { id, controller };
};
